<template>
  <validation-observer
    ref="form"
  >
    <div class="form-group">
      <label>{{ getPosterTrans('schedule_time') }}</label>
      <ok-date-time-picker
        v-model="form.schedule_time"
        type="datetime"
        :placeholder="getPosterTrans('schedule-date-placeholder')"
        :min-date="minDatetime"
        is-required
        hide-label
        label="التاريخ"
        :max-date="maxDate"
      />
    </div>
  </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import OkDateTimePicker from '@/@bya3/components/inputs/OkDateTimePicker'

export default {
  name: 'PosterSchedule',
  components: {
    OkDateTimePicker,
    ValidationObserver,
  },
  data() {
    return {
      minDatetime: '',
      maxDate: '',
    }
  },
  computed: {
    ...mapGetters({
      form: 'instagram/postForm',
    }),
  },
  mounted() {
    const today = new Date()
    today.setHours(today.getHours() + 1)
    this.minDatetime = today.toISOString()
    const max = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate())
    this.maxDate = max.toISOString()
  },
  methods: {
    getPosterTrans(str) {
      return this.$t(`poster.${str}`)
    },
  },
}
</script>
